import { gql } from "@apollo/client";

// Server-paginated list query for the Order Ahead Orders page.
export const ORDER_AHEAD_ORDERS_LIST_QUERY = gql`
  query OrderAheadOrdersList(
    $where: orders_order_ahead_bool_exp!
    $order_by: [orders_order_ahead_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    orders_order_ahead(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      reference_id
      created_at
      subtotal
      tax
      tip
      digital_surcharge
      status
      expo_status
      email
      phone_number
      processor_ref_id
      event {
        name
      }
      vendor {
        name
      }
      location {
        name
      }
    }
  }
`;

// Unpaginated variant — used to build the CSV export of every matching order.
export const ORDER_AHEAD_ORDERS_ALL_QUERY = gql`
  query OrderAheadOrdersAll(
    $where: orders_order_ahead_bool_exp!
    $order_by: [orders_order_ahead_order_by!]
  ) {
    orders_order_ahead(where: $where, order_by: $order_by) {
      id
      reference_id
      created_at
      subtotal
      tax
      tip
      digital_surcharge
      status
      expo_status
      email
      phone_number
      processor_ref_id
      event {
        name
      }
      vendor {
        name
      }
      location {
        name
      }
    }
  }
`;

export const ORDER_AHEAD_ORDERS_COUNT_QUERY = gql`
  query OrderAheadOrdersCount($where: orders_order_ahead_bool_exp!) {
    orders_order_ahead_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

// Distinct vendors that have order-ahead orders within the current event/org
// scope — powers the vendor filter dropdown.
export const ORDER_AHEAD_ORDER_VENDORS_QUERY = gql`
  query OrderAheadOrderVendors($where: orders_order_ahead_bool_exp!) {
    orders_order_ahead(
      where: $where
      distinct_on: vendor_id
      order_by: { vendor_id: asc }
    ) {
      vendor_id
      vendor {
        id
        name
      }
    }
  }
`;

export const GET_ORDER_AHEAD_ORDER = gql`
  query OrderAheadOrdersSingle($id: Int!) {
    orders_order_ahead_by_pk(id: $id) {
      id
      items
      subtotal
      tax
      status
      tip
      expo_status
      user_id
      transaction_at
      transaction_time
      location_order_ahead_id
      event_id
      phone_number
      digital_surcharge
      vendor_id
      processor_ref_id
      reference_id
      email
      promo_code_uid
      total_promo_discount
      promo_code
      created_at
      updated_at
      event {
        name
      }
      vendor {
        name
      }
      location {
        name
      }
    }
    transactions_order_ahead(where: { order_id: { _eq: $id } }) {
      id
      amount
      status
      payment {
        id
        amount
        status
        payment_type
      }
    }
  }
`;
